export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS'
export const GET_RELATED_COMMENTS_SUCCESS = 'GET_RELATED_COMMENTS_SUCCESS'
export const GET_COMMENT_SUCCESS = 'GET_COMMENT_SUCCESS'
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS'
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS'
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS'

export const API_REQUEST_START = 'API_REQUEST_START'
export const API_REQUEST_FAIL = 'API_REQUEST_FAIL'
